export default "__VITE_ASSET__RZbgBMpy__"